export var SOCKET_QUOTE_API_CHAT_URL_PATH = '/ws/chat/socket.io';